module.exports = __webpack_public_path__ + "img/chaoshi.c94e78a9.png";